// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.centered-image-slice .image[data-v-1ef34000]{width:100%}section.centered-image-slice .wrapper[data-v-1ef34000]{display:flex;flex-direction:column;align-items:center;justify-content:center;grid-gap:1rem;gap:1rem}section.centered-image-slice .wrapper.content-reverse[data-v-1ef34000]{flex-direction:column-reverse}section.centered-image-slice.remove-padding-y[data-v-1ef34000]{padding-top:0;padding-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
